import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from "react-query";

import { getDownloadURL, uploadBytesResumable } from "firebase/storage";
import "firebase/compat/firestore";
import { storage } from "../../../firebase";

import { fetchPosts, createPost, handleUpdatePost } from '../../../hooks/fetchFromFirebase';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Single = ({ id }) => {

  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const { data: posts = [] } = useQuery("posts", fetchPosts);

  const [selectedPost, setSelectedPost] = useState(null);
  const [newPost, setNewPost] = useState({
    title: "",
    excerpt: "",
    editor: "",
    image: "",
    date: new Date()
  });

  // Upload new post image
  const [imgUrl, setImgUrl] = useState(null);
  const [progresspercent, setProgresspercent] = useState(0);

  const handlePostImageSubmit = (file, callback) => {
    const storageRef = storage.ref(`posts/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);
  
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgresspercent(progress);
      },
      (error) => {
        alert(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setImgUrl(downloadURL);
          if (typeof callback === 'function') {
            callback(downloadURL);
          }
        });
      }
    );
  };

  // Create post
  const createPostMutation = useMutation(createPost, {
    onSuccess: (data) => {
      queryClient.setQueryData("posts", (oldData) => [...oldData, data]);
      setNewPost({ title: "", excerpt: "", imgUrl: "" });
      navigate("/dashboard/posts");
    }
  });
    
  const handleNewPostChange = (e) => {
    const { name, value } = e.target;
    if (name === "image") {
      setNewPost((prev) => ({ ...prev, [name]: e.target.files[0] }));
    } else {
      setNewPost((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleNewPostSubmit = (e) => {
    e.preventDefault();
    handlePostImageSubmit(newPost.image, (uploadedImgUrl) => {
      createPostMutation.mutate({ ...newPost, image: uploadedImgUrl });
    });
  };

  // Update post
  // const useUpdatePostMutation = () => {
  //   const queryClient = useQueryClient();
  
  //   return useMutation(({ postId, updatedPost }) => updatePost(postId, updatedPost), {
  //     // On success, invalidate the "posts" query to trigger a refetch
  //     onSuccess: () => {
  //       queryClient.invalidateQueries("posts");
  //     },
  //   });
  // };
    
    return (
      <div className='container equal-heights-container padding-vert-40'>
        <div className="title-container fs-3vw fw-900 blue vertical">
          {id ? `Επεξεργασία` : "Δημιουργία"}
        </div>

        <div className="content-container border-left-blue padding-left-20">
          <div className="row">
            <div className="col s12">
                <div className="fs-2vw fw-900 blue ta-center">{id ? `Επεξεργασία άρθρου` : "Δημιουργία άρθρου"}</div>
            </div>
          </div>
                  
          <div className="row">
            
              <div className="dashboard-form">
                <form onSubmit={handleNewPostSubmit}>
                  <div className="col s12">
                    <p className="form-label blue">Τίτλος</p>
                    <input
                      type="text"
                      name="title"
                      value={newPost.title}
                      onChange={handleNewPostChange}
                    />
                  </div>

                  <div className="col s12">
                    <p className="form-label blue">Σύντομη περιγραφή</p>
                    <textarea
                      name="excerpt"
                      value={newPost.excerpt}
                      onChange={handleNewPostChange}
                    ></textarea>
                  </div>

                  <div className="col s12">
                    <p className="form-label blue">Κείμενο</p>
                    
                  </div>

                  <div className="col s12">
                    <p className="form-label blue">Εικόνα</p>
                    <input
                      type="file"
                      name="image"
                      onChange={handleNewPostChange}
                    />
                  </div>
                  
                  <div className="row">
                    <div className="col s12 ta-center padding-vert-10">
                      <button type="submit">Δημιουργία</button>
                    </div>
                  </div>

                </form>
              </div>
        </div>
      </div>
    </div>
    );
  };
  
  export default Single;